import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { asyncScheduler, filter, map, Subject, SubscriptionLike, switchMap, takeUntil } from 'rxjs';
import { fadeTextAnimation, reboundAnimation } from './../../../../../assets/animations';
import { IDataEcommerceConfig, ISummaryPrice } from './../../../../private/shared/models/productos';
import { AppState } from './../../../../store/app-reducers';
import { SummaryPriceDefault } from './../../../models/Constants';
import { OperationsService } from './../../../services/operations/operations.service';

@Component({
  selector: 'getm-floating-cart',
  templateUrl: './floating-cart.component.html',
  styleUrls: ['./floating-cart.component.scss'],
  animations: [
    fadeTextAnimation,
    reboundAnimation,
  ]
})
export class FloatingCartComponent implements OnInit, OnDestroy {

  @Input() background: string = 'getm-secondary-default';
  @Input() iconColor: string = 'getm-neutral-white';
  @Input() topText: string = '';
  @Input() topTextColor: string = 'getm-neutral-white';
  @Input() bottomTextColor: string = 'getm-neutral-white';
  @Input() bonuses: boolean = false;
  @Input() bonusColor: string = 'getm-secondary-default';
  @Input() bonusBackground: string = 'getm-neutral-white';

  @Output() cartClick = new EventEmitter<void>();

  public maximum = 0;
  public position = 0;
  public dialStartAngle = 130;
  public dialEndAngle = 50;
  public summaryPrice: ISummaryPrice = SummaryPriceDefault;

  private finishSubscriptions: Subject<boolean> = new Subject();
  private subscription: SubscriptionLike | null = null;

  constructor(
    private store: Store<AppState>
    , private nav: NavController
    , private operationsS: OperationsService
  ) { }

  ngOnInit(): void {
    if ((this.operationsS.LimitMinCajas ?? 0) > 0) {
      this.maximum = this.operationsS.LimitMinCajas ?? 0;
    } else if ((this.operationsS.LimitMinMonto ?? 0) > 0) {
      this.maximum = this.operationsS.LimitMinMonto ?? 0;
    } else {
      this.maximum = 1;
    }

    const summaryPrice$ = this.operationsS.combinerCartOrder$().pipe(map(data => data.summaryPrice));
    this.store.select('ecommerceConfig')
      .pipe(
        filter(resp => resp.success),
        switchMap(resp => summaryPrice$.pipe(
          map(prices => ({ config: resp.respConfig, summaryPrice: prices }))
        )),
        takeUntil(this.finishSubscriptions)
      )
      .subscribe(this.callbackEcommerceConfig);
  }

  ngOnDestroy() {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
    if (this.subscription) this.subscription.unsubscribe();
  }

  private callbackEcommerceConfig = (data: { config: IDataEcommerceConfig; summaryPrice: ISummaryPrice }) => {
    this.summaryPrice = data.summaryPrice;

    this.subscription = asyncScheduler.schedule(() => {
      // El progreso es hacia el límite mínimo (no máximo)
      // Priorizar cajas sobre monto (misma lógica que purchase-limits-bar)
      if ((data.config.LimitMinCajas ?? 0) > 0) {
        this.position = data.summaryPrice.FactorCl ?? 0;
      } else if ((data.config.LimitMinMonto ?? 0) > 0) {
        this.position = data.summaryPrice.total_precio ?? 0;
      } else {
        this.position = 1;
      }
    }, 300); // Para animacion del Gauge
  }

  public onCartClick(): void {
    this.cartClick.emit(); // Posible analitics, para que se realice en el .page principal
    this.nav.navigateForward(['/Carrito'], { animated: true, animationDirection: 'forward' })
  }
}
